// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2HhcT","list":"PatternAutocomplete_list__3XkRI"};